module.exports = {
  context: {
    masthead: '@masthead',
    hero: {
      heading: {
        text: 'Our Work',
        tag: 'h1',
        class: 'heading-1'
      },
      breadcrumbs: '@breadcrumb'
    },

    sidebar: '@sidebar-subnavigation',
    contentModules: '@content-modules',
    footer: '@footer'
  }
}
